import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Loader } from "./Loader";
import { type LoaderDataProps, loaderDataSchema } from "./Loader.schema";
import { LOADER_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [LOADER_TAG_NAME]: { props: LoaderDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-loader": HTMLElement;
  }
}

function RWCLoader(props: LoaderDataProps): JSX.Element {
  return <Loader {...props} />;
}

componentManager.register(
  rwc(LOADER_TAG_NAME, {
    component: RWCLoader,
    dataSchema: loaderDataSchema,
  }),
);
